var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('img',_vm._g({staticClass:"pointer",attrs:{"height":"16px","src":require("@/assets/icons/copy-icon.svg"),"width":"16px"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('copyContent', _vm.isSelectedCell)}}},on))]}}])},[_c('span',[_vm._v("Copy content")])])}
var staticRenderFns = []

export { render, staticRenderFns }